import React, { useState, useEffect } from "react";
import {
  Input,
  Button,
  Select,
  message,
  Checkbox,
  Form,
  notification,
} from "antd";
import { ClipLoader } from "react-spinners";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import { getUserDataById } from "../../../API/Admin/user";
import { editUser } from "../../../API/Admin/user";
import { useParams } from "react-router-dom";
import "./style.css";

const { Option } = Select;

const ViewUserDetails = () => {
  const [form] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [saved, setSaved] = useState(false);
  const [users, setUsers] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const { id } = useParams();
  const [selectedRole, setSelectedRole] = useState("");

  const navigate = useNavigate();
  const errorNotification = (msg) => {
    messageApi.error(msg);
  };
  const handleSubmit = async (values) => {
    setLoadingUser(true);
    try {
      const res = await editUser(
        id,
        values?.fullName,
        values?.email,
        values?.phone_number,
        values?.role,
        values?.status,
        undefined,
        undefined,
        values?.permissions,
      );

      if (res.status >= 200 && res.status < 300) {
        messageApi.success(res.data?.message || "User updated successfully!");

        setTimeout(() => navigate("/allusers"), 1000);
      } else {
        errorNotification(res.data?.error || "Failed to update user.");
      }
    } catch (err) {
      const serverError = err.response?.data;
      let errorMessage = "Error updating user.";

      if (serverError) {
        if (typeof serverError === "string") {
          errorMessage = serverError;
        } else if (serverError.error || serverError.message) {
          errorMessage = serverError.error || serverError.message;
        } else if (typeof serverError === "object") {
          const fieldName = Object.keys(serverError)[0];
          const msg = Array.isArray(serverError[fieldName])
            ? serverError[fieldName][0]
            : serverError[fieldName];
          errorMessage = `${fieldName}: ${msg}`;
        }
      }

      errorNotification(errorMessage);
    } finally {
      setLoadingUser(false);
    }
  };

  const handlePasswordSubmit = async (values) => {
    setLoadingPassword(true);
    try {
      const res = await editUser(
        id,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        values.password,
        values.confirmPassword,
        undefined,
      );

      if (Math.floor(res.status / 100) === 2) {
        messageApi.success("Password updated successfully!");
        passwordForm.resetFields();
        setTimeout(() => navigate("/allusers"), 1000);
      } else {
        errorNotification("Failed to update password.");
      }
    } catch (err) {
      errorNotification("Error updating password.");
    } finally {
      setLoadingPassword(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSaved(false);
    message.info("Changes canceled");
  };

  const handleCancelPassword = () => {
    passwordForm.resetFields();
    message.info("Password changes canceled");
  };

  const fetchDataById = async (id) => {
    try {
      setLoadingFetch(true);
      const response = await getUserDataById(id);

      if (Math.floor(response?.status / 100) === 2) {
        const user = response?.data?.user;

        if (user) {
          form.setFieldsValue({
            fullName: user.name,
            email: user.email,
            phone_number: user.phone_number,
            role: user.role,
            status: user.status.toLowerCase(),
            undefined,
            undefined,
            permissions: user.permissions || [],
          });
          setSelectedRole(user.role);
        }
      } else {
        errorNotification("Unexpected response from server.");
      }
    } catch (err) {
      errorNotification("Failed to fetch user.");
    } finally {
      setLoadingFetch(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  return (
    <div className="new-user">
      <div className="new-user-container">
        {contextHolder}
        <Form
          className="new-user"
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <div className="add-new-user">
            <div className="heading">Edit User Details</div>

            <div className="user-details">
              <div className="input-group">
                <div className="title">Full Name</div>
                <Form.Item
                  name="fullName"
                  rules={[
                    { required: true, message: "Please enter full name!" },
                  ]}
                >
                  <Input placeholder="Enter Full Name" />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Email Address</div>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Please enter email!" },
                    { type: "email", message: "Enter a valid email!" },
                  ]}
                >
                  <Input placeholder="Enter Email Address" />
                </Form.Item>
              </div>
              <div className="input-group">
                <div className="title">Phone Number (Optional)</div>
                <Form.Item name="phone_number">
                  <PhoneInput
                    country={"jm"}
                    placeholder="Enter Contact Number"
                    inputClass="phone-input"
                    specialLabel={false}
                    onChange={(value) => {
                      form.setFieldsValue({
                        phone_number: value.startsWith("+")
                          ? value
                          : `+${value}`,
                      });
                    }}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="user-details">
              <div className="input-group">
                <div className="title">Role</div>
                <Form.Item
                  name="role"
                  rules={[{ required: true, message: "Please select role!" }]}
                >
                  <Select
                    placeholder="Select Role"
                    onChange={(value) => setSelectedRole(value)}
                  >
                    <Option value="admin">Admin</Option>
                    <Option value="user">User</Option>
                  </Select>
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Status</div>
                <Form.Item
                  name="status"
                  rules={[{ required: true, message: "Please select status!" }]}
                >
                  <Select placeholder="Select Status">
                    <Option value="active">Active</Option>
                    <Option value="inactive">Inactive</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
          </div>

          {selectedRole === "user" && (
            <div className="permissions">
              <div className="heading">Role Base Permissions</div>
              <div className="checkbox-row">
                <Form.Item
                  name="permissions"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one permission!",
                    },
                  ]}
                >
                  <Checkbox.Group
                    options={[
                      { label: "Monitoring", value: "monitoring" },
                      { label: "Security & Incidents", value: "security" },
                      { label: "Geoenforcing", value: "geoenforcing" },
                      { label: "Customer Management", value: "customer" },
                    ]}
                  />
                </Form.Item>
              </div>
            </div>
          )}
          <div className="form-actions">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              loading={loadingUser}
              className="save-user"
              type="primary"
              htmlType="submit"
            >
              Save Changes
            </Button>
          </div>
        </Form>
      </div>
      <div className="add-new-user">
        <div className="heading">Change Password</div>
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handlePasswordSubmit}
        >
          <div className="user-details">
            <div className="input-group">
              <div className="title">New Password</div>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Please enter password!" }]}
              >
                <Input.Password placeholder="Enter New Password" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Confirm Password</div>
              <Form.Item
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please confirm password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!"),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>

      <div className="form-actions">
        <Button onClick={handleCancelPassword}>Cancel</Button>
        <Button
          className="submit-btn"
          type="primary"
          loading={loadingPassword}
          onClick={() => passwordForm.submit()}
        >
          Update Password
        </Button>
      </div>
    </div>
  );
};

export default ViewUserDetails;
